import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { editStaticContent } from "../../features/slices/staticContentManagement";
import { toastService } from "../../utils/toastify";
import { canPerformAction } from "../../utils/denyAccess";

const ContentManagement = ({ data }) => {
  const [showEditField, setShowEditField] = useState(false);
  const [errors, setErrors] = useState({});
  const [content, setContent] = useState(data?.description);
  const dispatch = useDispatch();
  const handleEditShow = () => {
    setShowEditField(!showEditField);
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!content?.trim()) {
      formErrors.content = "content is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };
  const handleEdit = () => {
    const EditData = {
      staticId: data?._id,
      description: content,
    };
    if (validateForm()) {
      dispatch(editStaticContent(EditData)).then((res) => {
        if (res?.payload?.code) {
          toastService.success("Edit SuccessFully");
          setShowEditField(false);
        } else {
          toastService.error(res?.data?.message);
          console.log(res?.data?.message);
        }
      });
    }
  };
  return (
    <div className="TextBox">
      <div className="d-flex mb-2 justify-content-between">
        <h6>{data?.title}</h6>
        {canPerformAction("Static-Content") && (
          <a onClick={handleEditShow} className="mr-2">
            <i className="fa-regular fa-pen-to-square" />
          </a>
        )}
      </div>
      <aside>
        {showEditField ? (
          <>
            <textarea
              className="form-control border-0"
              rows="5"
              value={content}
              onChange={(e) => {
                setErrors("");
                setContent(e?.target?.value);
              }}
            ></textarea>
            {errors.content && (
              <div className="alert alert-danger">{errors.content}</div>
            )}
          </>
        ) : (
          <p>{content}</p>
        )}
      </aside>
      {showEditField && (
        <Button className="Button mb-2" onClick={handleEdit}>
          Save
        </Button>
      )}
    </div>
  );
};

export default ContentManagement;
